module.exports = __webpack_public_path__ + "static/media/perspective-taking@3x.590eaf0d.png";